import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi, setToken, clearToken, getToken, formatApiErrorDetail } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=auth

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setUser(null);
      return;
    }
    authApi
      .me()
      .then((res) => setUser(res.data))
      .catch(() => {
        clearToken();
        setUser(null);
      });
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const res = await authApi.login(email, password);
      setToken(res.data.access_token);
      setUser(res.data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  }, []);

  const logout = useCallback(() => {
    authApi.logout().catch(() => {});
    clearToken();
    setUser(null);
  }, []);

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
